import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../api/api";
import toast from "react-hot-toast";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem("aksubeb_admin_token");

  const loadAdmin = async () => {
    if (!token) {
      setLoading(false);
      return;
    }

    try {
      const res = await api.get("/auth/me");
      setAdmin(res.data);
    } catch {
      localStorage.removeItem("aksubeb_admin_token");
      setAdmin(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadAdmin();
  }, []);

  const login = async (email, password) => {
    const res = await api.post("/auth/login", { email, password });

    localStorage.setItem("aksubeb_admin_token", res.data.access_token);
    setAdmin(res.data.admin);

    toast.success("Login successful");

    return res.data;
  };

  const logout = () => {
    localStorage.removeItem("aksubeb_admin_token");
    setAdmin(null);
    toast.success("Logged out");
  };

  return (
    <AuthContext.Provider
      value={{
        admin,
        loading,
        login,
        logout,
        isAuthenticated: !!admin,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);